import type { PlatformAdapter, PlatformName } from './adapter';
import { crazygamesAdapter } from './adapters/crazygames';
import { gamedistributionAdapter } from './adapters/gamedistribution';
import { pokiAdapter } from './adapters/poki';
import { standaloneAdapter } from './adapters/standalone';
import { youtubeAdapter } from './adapters/youtube-playables';

export function pickAdapter(name: PlatformName): PlatformAdapter {
  switch (name) {
    case 'youtube':
      return youtubeAdapter;
    case 'poki':
      return pokiAdapter;
    case 'crazygames':
      return crazygamesAdapter;
    case 'gamedistribution':
      return gamedistributionAdapter;
    case 'standalone':
      return standaloneAdapter;
    default:
      return standaloneAdapter;
  }
}
